import { Fragment, useEffect, useState } from 'react'
import { useHubspotForm } from 'next-hubspot'
import BeatLoader from 'react-spinners/BeatLoader'
import { HUBSPOT_CONFIG } from '@/utils/hubspotConfig'

const Subscribe = () => {
  const { loaded, error, formCreated } = useHubspotForm(HUBSPOT_CONFIG.subscribe)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const handleOnLoadingForms = () => {
      setLoading(false)
    }
    window.addEventListener('hs-form-event:on-ready', handleOnLoadingForms)
    return () => {
      window.removeEventListener('hs-form-event:on-ready', handleOnLoadingForms)
    }
  }, [])

  // Error Handling
  useEffect(() => {
    if (error) {
      console.error('HubSpot Form Error:', error)
    }
  }, [error])

  return (
    <Fragment>
      {loading && (
        <div className="flex justify-center items-center pt-6 pb-20">
          <BeatLoader color="white" size={20} className="m-auto" />
        </div>
      )}

      <div className="uta-container h-auto pb-16" id="hubspot-form-wrapper-subscribe"></div>
    </Fragment>
  )
}

export default Subscribe